
import React from "react";
import { Row, Col, Card, Image } from 'react-bootstrap';
import forbiddenImg from "../assets/img/illustrations/500.svg";
export default (props) => {
  return (
    <div style={{backgroundColor: "var(--bs-soft)", height: "100%"}}>
        <Row className="justify-content-md-center" style={{height: "100%"}}>
          <Col xs={12} lg={6} className="mb-4 mb-lg-0 text-center">
            <Card>
                <Card.Header className="alert-danger bg-danger">
                    <h1>¡No tienes acceso a esta vista!</h1>
                </Card.Header>
                <Card.Body>
                    <Image src={forbiddenImg}></Image>
                </Card.Body>
            </Card>
          </Col>
        </Row>
    </div>
  );
};
